import { createSlice } from '@reduxjs/toolkit'
import { FleetState } from './types'

const initialState: FleetState = {
  errorMessage: '',
  pendingCarsCount: 0,
}

export const fleetSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setFleetErrorMessage(state, action) {
      state.errorMessage = action.payload
    },
    setPendingCarsCount(state, action) {
      state.pendingCarsCount = action.payload
    },
  },
})

export const fleetReducer = fleetSlice.reducer
export const { setFleetErrorMessage, setPendingCarsCount } = fleetSlice.actions
